
import { Typography, Grid, Modal, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from './dashboardStyles'
import Group1 from '../../../../ui-assets/Group1.svg'
import Group2 from '../../../../ui-assets/Group2.svg'

const EchoSoundTest = ({
    classes, soundModal, playButton, unclearVoice, handleEchoTest, handleHangup, handleUnClearVoice, handleCloseSoundModal
}) => {

    return (
        <>
            <Modal
                className={classes.modalcard}
                open={soundModal}
                style={{ marginLeft: '360px', marginTop: '190px' }}
                BackdropProps={{
                    style: {
                        backgroundColor: 'rgba(0, 0, 0, 0)'
                    },
                }}
            >
                {!playButton ?
                    <Grid container >
                        <Grid item style={{ display: 'flex', alignItems: 'center', marginLeft: '276px', marginTop: '40px' }}>
                            <img
                                src={require('../../../../ui-assets/Ellipse.png')}
                                alt=" Agent Icon"
                                style={{
                                    width: '35px', height: '35px', flexShrink: '0', borderRadius: '35px',
                                    background: 'url(<path-to-image>) lightgray 50% / cover no-repeat',
                                    marginRight: '10px'
                                }}
                            />

                            <Typography className={classes.modalheading}>
                                Echo/ Sound Test
                            </Typography>

                            <img
                                src={require('../../../../ui-assets/XFrame.png')}
                                alt=" X Icon"
                                onClick={handleCloseSoundModal}
                                style={{
                                    width: '24px', height: '24px', flexShrink: '0', marginLeft: '150px', cursor: 'pointer'

                                }}
                            />
                        </Grid>

                        <Grid item className={classes.voicelayout} style={{ display: 'flex', alignItems: 'center', marginLeft: '32px', marginTop: '16px' }}>
                            <img
                                src={require('../../../../ui-assets/voiceplay.png')}
                                alt="playIcon"
                                onClick={handleEchoTest}
                                style={{
                                    width: '57px', height: '57px', flexShrink: 0, marginLeft: '24px', cursor: 'pointer'
                                }}
                            />

                            <div style={{ marginLeft: '20px', marginTop: '2px' }}>
                                <Typography className={classes.voiceheading} >Voice Test</Typography><br />
                                <Typography className={classes.voicetext} >Please speak and test your voice by pressing Play button</Typography>
                            </div>
                        </Grid>
                    </Grid>
                    :
                    <Grid container >
                        <Grid item style={{ display: 'flex', alignItems: 'center', marginLeft: '276px', marginTop: '40px' }}>
                            <img
                                src={require('../../../../ui-assets/Ellipse.png')}
                                alt=" Agent Icon"
                                style={{
                                    width: '35px', height: '35px', flexShrink: '0', borderRadius: '35px',
                                    background: 'url(<path-to-image>) lightgray 50% / cover no-repeat',
                                    marginRight: '10px'
                                }}
                            />

                            <Typography className={classes.modalheading}>
                                Echo/ Sound Test
                            </Typography>

                            <img
                                src={require('../../../../ui-assets/XFrame.png')}
                                alt=" X Icon"
                                onClick={handleCloseSoundModal}
                                style={{
                                    width: '24px', height: '24px', flexShrink: '0', marginLeft: '150px', cursor: 'pointer'

                                }}
                            />
                        </Grid>

                        <Grid item className={classes.voicelayout} style={{ display: 'flex', alignItems: 'center', marginLeft: '32px', marginTop: '16px' }}>
                            <img
                                src={Group1}
                                alt="Group Icon"

                                style={{
                                    width: '57px', height: '57px', flexShrink: 0, fill: 'var(--CTA, #F74542)', marginLeft: '24px', cursor: 'pointer'
                                }}

                            />

                            <div style={{ marginLeft: '20px', marginTop: '2px' }}>
                                <Typography className={classes.voiceheading} >Speak now</Typography>
                                <div className={classes.rectanglebox} style={{ display: 'flex', marginTop: '20px' }}>
                                    {Array(7).fill().map((_, index) => (

                                        <div key={index}
                                            className={index === 0 ? classes.rectanglebox1 : index === 1 ? classes.rectanglebox2 : index === 2 ? classes.rectanglebox3 :
                                                (unclearVoice ? classes.rectanglebox6 : index === 3 ? classes.rectanglebox4 : index === 4 ? classes.rectanglebox5 : classes.rectanglebox6)
                                            }
                                            style={{ marginRight: '5px' }}
                                        />
                                    ))}
                                </div>
                            </div>
                        </Grid>

                        <Grid style={{ alignItems: 'center', marginLeft: '276px', marginTop: '24px' }}>
                            <Typography className={classes.modalheading}>Select below option</Typography>
                        </Grid>

                        {unclearVoice ? <Grid style={{ marginLeft: '70px', marginTop: '15px', display: 'flex' }}>

                            <img
                                src={Group2}
                                alt=" Polygon Icon"
                                style={{
                                    width: '43px', height: '43px', flexShrink: '0', fill: '#F4D553'

                                }}
                            />

                            <Typography className={classes.reportedtext} style={{ marginTop: '15px' }}>You reported unclear voice, Reach-out to admin and get resolved your issue.</Typography>
                        </Grid>
                            :
                            <>
                                <Grid>
                                    <Button className={classes.voicebuttonlayout} style={{ marginTop: '15px', marginLeft: '35px' }} onClick={handleHangup}>
                                        <span className={classes.clearvoicetext} style={{ textTransform: 'none' }} >Clear Voice</span>

                                    </Button >

                                </Grid>
                                <Grid>
                                    <Button className={classes.unclearbuttonlayout} style={{ marginTop: '15px', marginLeft: '28px' }}>
                                        <span className={classes.unclearvoicetext} style={{ textTransform: 'none' }} onClick={handleUnClearVoice}>Unclear Voice</span>
                                    </Button>
                                </Grid>
                            </>
                        }
                    </Grid>
                }
            </Modal>
        </>
    )
}

export default withStyles(styles)(EchoSoundTest)